<template>
  <div class="row">
      <div class="col-md-12">
        <h4 class="title">{{$t("country_crop")}}</h4>
      </div>

      <div class="col-md-12 card">
        <div class="card-header">
           <div class="row">
              <div class="col-md-6">
                <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                  <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-sm-6">
                <div class="pull-right">
                  <fg-input
                    class="input-sm"
                    :placeholder="$t('search')"
                    v-model="searchQuery"
                    addon-right-icon="nc-icon nc-zoom-split"
                  ></fg-input>
                </div>
              </div>
            </div>
        </div>
        <div class="card-body">

            <div class="row mt-2">
            <el-table v-loading="loading" :element-loading-text="$t('loading_data') + '...'" class="table-striped" :data="paginated" border style="width: 100%">
              <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" sortable></el-table-column>
              <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('crops')">
                <template slot-scope="props">

                  <p-button type="primary" size="sm" icon @click="handleEditModal(props.$index, props.row)">
                    <i class="fa fa-eye"></i>
                  </p-button>

                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>

        <div class="card-footer">
          <paginate :pagination="pagination" :metadata="metaData" :allData="getAllCategories"></paginate>
        </div>

      </div>

       <!-- Add Modal -->
      <modal :show.sync="modals.classic" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">{{ $t('new_country_crop') }}</h4>
        <ValidationObserver ref="cropForm">
          <form>

            <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
              <fg-input :error="errors[0]" v-model="form.name" disabled :placeholder="$t('name')" :label="$t('name')"></fg-input>
            </ValidationProvider>

            <fg-input :label="$t('crops_to_country')">
              <el-select size="large"
                      multiple
                      filterable
                      v-model="form.crops"
                      :placeholder="$t('select_crops')"
                      value-key="id">
                  <el-option
                   class="select-primary"
                   v-for="crop in allCrops"
                   :key="crop.id"
                   :label="crop.commonName"
                   :value="crop"></el-option>
              </el-select>
            </fg-input>

          </form>
        </ValidationObserver>
        <template slot="footer">
          <div class="left-side">
            <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
          </div>
          <div class="divider"></div>
          <div class="right-side">
            <p-button type="primary" link @click="createCrop">{{ $t('save') }}</p-button>
          </div>
        </template>
      </modal>

  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
import Modal from "src/components/UIComponents/Modal.vue";
import Paginate from '../../../../UIComponents/Paginate.vue';
import Con from "@/util/helpers.js";

const CategoryAllResource = new Resource("category/children/Countries");
const CropResource = new Resource("all/crops");
const SaveCropResource = new Resource("country/crops");

export default {
  components: {
     Modal,
     Paginate
  },
  data() {
    return {
       modals: {
        classic: false
      },
      form: {
        name:'',
        country_id:'',
        crops:[]
      },
      pagination: {
        perPage: 10,
        perPageOptions: [10, 20, 30, 60, 500, 1000],
        currentPage:1,
        nextPage:'',
        prevPage:'',
        total:'',
        from:'',
        to:'',
        page:'',
      },
      searchQuery:'',
      loading: false,
      updateState: false,
      tableData: [],
      allCrops:[],
      tableColumns: [
        {
          prop: "id",
          label: this.$t("id"),
          minWidth: 30
        },
        {
          prop: "name",
          label: this.$t("name"),
          minWidth: 200
        }
      ],
      metaData: {
         meta:'',
         links:''
      },
    }
  },

  methods: {

    handleEditModal(index, row) {
      this.form.name = row.name;
      this.form.country_id = row.id;
      this.form.crops = row.crops;
      this.modals.classic = true
    },

    handleCloseModal() {
       this.form.name = "";
       this.form.crops = [];
       this.modals.classic = false;
    },

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    async getAllCategories(page_url) {
      this.loading = true;
      if(page_url) {
         page_url = Con.splitStringLinks(page_url);
      }

      await CategoryAllResource.list(page_url)
      .then(response => {
          this.loading = false;

          if(this.tableData.length > 0) {
            this.tableData = [...response.data.data, ...this.tableData];
          } else {
            this.tableData = response.data.data;
          }

          this.metaData.meta = response.data.meta;
          this.metaData.links = response.data.links;
        }).catch(error => {
          console.log('error', error);
          this.loading = false;
        });
    },

    async getAllCrops() {
        await CropResource.list({})
        .then((res) => {
           this.allCrops = res.data;
        }).catch(error => {
            console.log('error', error);
        });
    },

    async createCrop() {
       let formData = new FormData();

       await this.form.crops.forEach(element => {
           formData.append('id[]', element.id)
           formData.append('crop_id[]', element.crop_id);
           formData.append('crop_name[]', element.name);
           formData.append('commonName[]', element.commonName);
           formData.append('created_at[]', element.created_at);
       });

       formData.append('country_id', this.form.country_id);
       formData.append('name', this.form.name);

      await SaveCropResource.store(formData)
        .then(response => {
           this.handleCloseModal();
           this.showAlertMessage(this.$t("crop_assigned"), "success");
           this.getAllCategories();
        })
        .catch(error => {
          this.showAlertMessage(error.response.errors, "error");
          if (error.response.data.errors) {
             this.$refs.cropForm.setErrors(error.response.data.errors);
          }
      });
    },

  },

  created() {
     this.getAllCategories();
     this.getAllCrops();
  },

  computed: {
    queriedData() {
        return Con.filterData(this.tableData, this.searchQuery);
    },

    paginated() {
        return Con.paginateData(this.queriedData, this.pagination);
    },
  },

}
</script>
<style lang="scss">
  .cropTable {
      height: 20px;
      overflow: auto;

      tbody {
         display: block;
         height: 30em;
         overflow: auto;

         tr {
            display: table;
            width: 100%;
            table-layout: fixed;
         }
      }
  }

  .cropBody {
     height: 40em;
     overflow: auto;
  }
</style>
